'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'box-taped';
var width = 448;
var height = 512;
var aliases = ["box-alt"];
var unicode = 'f49a';
var svgPathData = ['M0 144L61.2 46.1C72.9 27.4 93.4 16 115.5 16l76.5 0-32 128-160 0zm160 0l0 112 128 0 0-112-128 0zM256 16l76.5 0c22.1 0 42.6 11.4 54.3 30.1L448 144 288 144 256 16z', 'M160 144L0 144 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-272-160 0 0 112-128 0 0-112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxTaped = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;